/**
 * 统一请求封装。
 * 约定：HTTP 200 且 body.err_code === 0 为成功。
 *
 * 注意：生产环境接口为 http://trust.i3w.com.cn/api；
 * 分享页若用 https 打开会被浏览器/微信拦截混合内容，需用 http 链接（见 public/index.html 跳转）。
 */
const BASE = (process.env.VUE_APP_API_BASE || '').replace(/\/$/, '')

function requestFailedHint() {
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    return '网络请求失败：页面为 https，但接口为 http，请使用 http 链接打开或配置 HTTPS 接口'
  }
  return '网络请求失败，请检查网络或接口跨域配置'
}

// 接口的 OPTIONS 返回 401，任何触发预检的请求都会被跨域拦截。
// GET 只保留 CORS 安全头（不带 Content-Type），使其成为简单请求。
function getHeaders(token) {
  const headers = { Accept: 'application/json' }
  if (token) headers.Authorization = `Bearer ${token}`
  return headers
}

function postHeaders(token) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
  if (token) headers.Authorization = `Bearer ${token}`
  return headers
}

async function parseResponse(res) {
  if (!res.ok) {
    throw new Error(`网络错误 (${res.status})`)
  }
  const body = await res.json()
  if (body == null || typeof body !== 'object') {
    throw new Error('返回数据异常')
  }
  if (Number(body.err_code) !== 0) {
    throw new Error(body.err_msg || body.message || '请求失败')
  }
  return body.data
}

export async function get(path, params = {}, { token } = {}) {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    query.set(key, String(value))
  })
  const qs = query.toString()
  const url = `${BASE}${path}${qs ? `?${qs}` : ''}`

  let res
  try {
    res = await fetch(url, {
      method: 'GET',
      headers: getHeaders(token),
    })
  } catch (_) {
    throw new Error(requestFailedHint())
  }
  return parseResponse(res)
}

export async function post(path, data = {}, { token } = {}) {
  const url = `${BASE}${path}`
  let res
  try {
    res = await fetch(url, {
      method: 'POST',
      headers: postHeaders(token),
      body: JSON.stringify(data),
    })
  } catch (_) {
    throw new Error(requestFailedHint())
  }
  return parseResponse(res)
}
